import React, { useState } from 'react';

interface Guest {
  id: number;
  firstName: string;
  lastName?: string;
  message?: string;
  messageForCaterer: boolean;
}

interface MessagesPanelProps {
  guests: Guest[];
  onToggleCaterer: (guestId: number, value: boolean) => void;
}

const MessagesPanel: React.FC<MessagesPanelProps> = ({ guests, onToggleCaterer }) => {
  const [filter, setFilter] = useState<'all' | 'caterer'>('all');
  const [searchQuery, setSearchQuery] = useState('');

  const guestsWithMessages = guests.filter((g) => g.message && g.message.trim() !== '');

  let filtered = guestsWithMessages;
  if (filter === 'caterer') {
    filtered = filtered.filter((g) => g.messageForCaterer);
  }

  if (searchQuery.trim()) {
    const query = searchQuery.toLowerCase().trim();
    filtered = filtered.filter((g) => {
      const fullName = `${g.firstName} ${g.lastName || ''}`.toLowerCase();
      const message = (g.message || '').toLowerCase();
      return fullName.includes(query) || message.includes(query);
    });
  }

  const catererCount = guestsWithMessages.filter((g) => g.messageForCaterer).length;

  return (
    <div className="messages-panel">
      <div className="messages-header">
        <div className="messages-stats">
          <span className="messages-stat">
            {guestsWithMessages.length} message{guestsWithMessages.length !== 1 ? 's' : ''}
          </span>
          <span className="messages-stat caterer-stat">
            {catererCount} pour le traiteur
          </span>
        </div>
        <div className="messages-controls">
          <div className="messages-filter-buttons">
            <button
              className={`messages-filter-btn ${filter === 'all' ? 'active' : ''}`}
              onClick={() => setFilter('all')}
            >
              Tous
            </button>
            <button
              className={`messages-filter-btn ${filter === 'caterer' ? 'active' : ''}`}
              onClick={() => setFilter('caterer')}
            >
              Traiteur
            </button>
          </div>
          <input
            type="text"
            className="messages-search"
            placeholder="Rechercher..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="messages-empty">
          {filter === 'caterer' ? 'Aucun message traiteur' : 'Aucun message'}
        </div>
      ) : (
        <div className="messages-list">
          {filtered.map((guest) => (
            <div key={guest.id} className={`message-card ${guest.messageForCaterer ? 'is-caterer' : ''}`}>
              <div className="message-card-header">
                <span className="message-guest-name">
                  {guest.firstName} {guest.lastName || ''}
                </span>
                <label className="caterer-toggle" onClick={(e) => e.stopPropagation()}>
                  <input
                    type="checkbox"
                    checked={guest.messageForCaterer}
                    onChange={(e) => onToggleCaterer(guest.id, e.target.checked)}
                  />
                  <span className="caterer-toggle-label">Traiteur</span>
                </label>
              </div>
              <p className="message-content">{guest.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MessagesPanel;
